import { notifyOrgAdminsAboutMissingPeerSupport } from '@/services/api/requests/notifications';
import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';

const useNotifyOrgAdminsAboutMissingPeerSupport = (onSuccessCallback: () => void) => {
  const toast = useToast();

  const { isSuccess, isPending, mutate } = useMutation({
    mutationFn: async () => {
      const response = await notifyOrgAdminsAboutMissingPeerSupport();
      return response;
    },
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Success',
        description: 'Organization Admin successfully notified.',
      });

      onSuccessCallback();
    },
    onError: () => {},
  });

  return { isPending, isSuccess, mutate };
};

export default useNotifyOrgAdminsAboutMissingPeerSupport;
